import React, { useState } from "react";
import Loading from "../components/Loading";

function HowToVideos () {

  const [loading, setLoading] = useState(true);

  return (
    <React.Fragment >
      {loading && <div style={{ paddingTop: "20vh" , paddingLeft: "8vh" }}><Loading>Loading ...</Loading></div>}
      <div>
        <iframe id="iframe" onLoad={() => setLoading(false)} style={{ "position": "absolute", "height": "calc(100vh - 89px)", "border": "none", "top": "89px", "width": "100%" }} src="https://scribehow.com/page/SiteSupt_OnDemand_Training__VvmZ_M9iTR2RZGTZ2LaFtA" title="HowToVideos" />
      </div>
    </React.Fragment>
  );
}

export default HowToVideos;